import {
  ColumnData,
  OrderTypeProps,
  ProductsProps,
  ProductTypeFileds,
} from '../interface/interface';
import { Table } from './Table';
import Select from 'react-select';
import { productStatusList } from '../constant/constant';
import { Link } from 'react-router-dom';
import { useMainRef } from '../context/pageScrollContext';
import { useEffect } from 'react';
import formatePriceByCost from '../utils/formatPriceByCost';
import AdminNonScriptRangeFilters from './AdminNonScriptRangeFilters';
import BundleScriptRangeFilters from './AdminBundlesFilters';

export default function Products({
  loading,
  dataProps,
  searchProps,
  filterProps,
  sortProps,
  paginationProps,
  type,
}: Readonly<ProductsProps>) {
  const mainRef = useMainRef();

  useEffect(() => {
    if (!mainRef?.current) return;

    const savedPosition = localStorage.getItem('product');
    if (savedPosition) {
      if (mainRef.current) {
        setTimeout(() => {
          mainRef.current!.scrollTo({
            top: Number(savedPosition),
            behavior: 'smooth',
          });
        }, 1000);
      }
    }
  }, [mainRef]);

  const columns: Array<ColumnData> = [
    {
      key: 'name',
      header: () => 'Name',
      isSortable: true,
      cell: (info) => (
        <Link
          to={`/product/${info?.row?.original?.product_code}`}
          state={{ type, from: window.location.pathname }}
          className="underline"
        >
          {info.getValue()}
        </Link>
      ),
    },
    {
      key: 'product_brand',
      header: () => 'Brand',
      isSortable: true,
      cell: (info) => info.getValue(),
    },
    {
      key: 'dayornight',
      header: () => 'Day / Night',
      isSortable: true,
      cell: (info) => info.getValue() ?? '-',
    },
    {
      key: 'product_strength',
      header: () => {
        return (
          <div>
            <p>Strength</p>
            <p>(CBD:THC)</p>
          </div>
        );
      },
      isSortable: true,
      cell: (info) => info.getValue() ?? '-',
    },
    {
      key: 'category',
      header: () => 'Category',
      isSortable: true,
      cell: (info) => info.getValue() ?? '-',
    },

    {
      key: 'formulation',
      header: () => 'Form',
      isSortable: true,
      cell: (info) => info.getValue() ?? '-',
    },
    {
      key: 'tga',
      header: () => 'TGA',
      isSortable: true,
      cell: (info) => info.getValue() ?? '-',
    },
    {
      key: 'inventory_quantity',
      header: () => 'Stock on Hand',
      isSortable: true,
      cell: (info) => {
        const qty = info.row.original.inventory_quantity;
        return <p>{qty > 0 ? qty : 'out-of-stock'}</p>;
      },
    },
    {
      key: 'price',
      header: () => 'Price',
      isSortable: true,
      cell: (info) => `$${info.getValue()}`,
    },
    {
      key: 'cost',
      header: () => 'Cost per',
      isSortable: true,
      cell: (info) => {
        const price = info?.row?.original?.price;
        const unit = info?.row?.original?.unit;
        const weight = info?.row?.original?.weight;

        return formatePriceByCost(price, unit, weight);
      },
    },
    {
      key: 'eta',
      header: () => 'Expiry / ETA',
      isSortable: true,
      cell: (info) => info.getValue() ?? '-',
    },
  ];

  return (
    <>
      <div className="flex items-center mb-5">
        <small className="ml-5">Status</small>
        <Select
          className="w-48 cursor-pointer ml-2"
          value={filterProps.filter}
          options={productStatusList}
          onChange={(selected) => filterProps.setFilter(selected)}
          isSearchable={false}
        />

        {type !== ProductTypeFileds.BUNDLES ? (
          <div className="flex items-center">
            <BundleScriptRangeFilters {...sortProps} {...dataProps} />
          </div>
        ) : (
          <></>
        )}

        {type === ProductTypeFileds.NON_SCRIPT_RANGE ? (
          <AdminNonScriptRangeFilters
            setSortByCondition={sortProps.setSortByCondition}
            productCondition={dataProps.productCondition}
            sortByCondition={sortProps.sortByCondition}
          />
        ) : (
          <></>
        )}
      </div>
      <Table
        columns={columns}
        data={dataProps.data}
        enablePagination={true}
        enableSorting={true}
        enableSearch={true}
        pagintation={paginationProps}
        search={searchProps}
        childLoader={loading}
        order={OrderTypeProps.PRODUCT}
      />
    </>
  );
}
